import * as THREE from "../../libs/three.js/build/three.module.js";
import {computeScreenSpaceScale, ScreenSpaceSizes} from "./ScreenSpaceScale.js";

// Den lille blå kugle ved cursoren: viser det punkt i punktskyen (eller snap-mål), som cursoren peger på - dvs. hvor et
// venstreklik vil lægge punktet. Fælles for ALLE Digitaliserings-værktøjer: DigitizationModule ejer én instans og viser den,
// så længe et værktøj er aktivt (ingen værktøj fra sig selv skal have en egen cursor-markør).
//
// Samme blå og form som punkterne selv (FeatureVisual: COLOR_DEFAULT, kugle med radius 1 i verdensrum, skaleret til en fast
// pixelstørrelse via ScreenSpaceScale). Tidligere viste nogle værktøjer i stedet en lille gul "pyramide" (oktaeder) - det er
// erstattet af denne kugle.
export const CURSOR_MARKER_COLOR = 0x2f8fd6;

export class CursorPointMarker extends THREE.Mesh{
	constructor(){
		super(
			new THREE.SphereGeometry(1, 16, 16),
			new THREE.MeshLambertMaterial({color: CURSOR_MARKER_COLOR, depthTest: false, depthWrite: false}),
		);
		this.name = "digitization-cursor-marker";
		this.visible = false;
		this.renderOrder = 1000;
		// aldrig et raycast-hit: markøren ligger lige under cursoren og må ikke stjæle hover/klik fra punkter, kanter og flader
		this.raycast = () => {};
	}

	show(position){
		this.position.copy(position);
		this.visible = true;
	}

	hide(){
		this.visible = false;
	}

	// Konstant skærmstørrelse (kaldes hver frame fra DigitizationModule.update()), så den følger zoom/kamera.
	refreshScale(camera, width, height){
		if(!this.visible) return;
		const s = computeScreenSpaceScale(camera, this.position, camera.position, width, height, ScreenSpaceSizes.vertex);
		this.scale.set(s, s, s);
	}
}
